import { useSelector } from "react-redux";
import store from "src/storeWire";
import {
    getAllTabsCount,
    getContentTabCount,
    getDocumentList,
    getDocumentListAutosuggest,
} from "../store/slice/model/HomePageContent"
import HomePageContentRepository from "src/repository/HomePageContentRepository";

export function useHomePageContentStore() {
    const contentCount = useSelector((state) => state.entities.model_HomePageContent.contentCount)
    const allTabsCount = useSelector((state) => state.entities.model_HomePageContent.allTabsCount)
    const contentTabCount = useSelector((state) => state.entities.model_HomePageContent.contentTabCount)
    const documentContentAutosuggestList = useSelector((state) => state.entities.model_HomePageContent.documentContentAutosuggest.list)
    const documentContentList = useSelector((state) => state.entities.model_HomePageContent.documentContent.list)
    const documentContentFacets = useSelector((state) => state.entities.model_HomePageContent.documentContent.facets)
    const documentContentCount = useSelector((state) => state.entities.model_HomePageContent.documentContent.count)

    let data = {
        documentContentAutosuggestList,
        documentContentFacets,
        documentContentList,
        documentContentCount,
        contentCount,
        allTabsCount,
        contentTabCount,
    };

    let fetch = {
        get_content_tab_count: async (params) => {
            return await store.dispatch(getContentTabCount({ searchParam: params }))
        },
        get_all_tab_count: async (params) => {
            return await store.dispatch(getAllTabsCount(params))
        },
        get_document_list: async (search, page, limit, orderByDirection = "asc", orderBy = "DocumentType", selectedFilterList = [], dateRangeObject) => {
            return await store.dispatch(getDocumentList({
                search,
                page,
                limit,
                orderByDirection,
                orderBy,
                selectedFilterList,
                dateRangeObject
            }))
        },
        get_document_list_autosuggest: async (search, page, limit, orderByDirection = "asc", orderBy = "DocumentType", selectedFilterList = [], dateRangeObject) => {
            return await store.dispatch(getDocumentListAutosuggest({
                search,
                page,
                limit,
                orderByDirection,
                orderBy,
                selectedFilterList,
                dateRangeObject
            }))
        },
       
        // NEW - DT
        get_home_page_content: async (params) => {
            return await new HomePageContentRepository().getHomePageContent(params);
        },
    };
    let set = {};
    return [data, fetch, set]
}